<div class="booking"
  role="link"
  tabindex="0"
  (click)="goToBooking()"
  (keydown.enter)="goToBooking()"
  (keydown.space)="goToBooking(); $event.preventDefault()"
>
  <div class="booking__column booking__service">
    <div class="booking__image">
      @if (booking.service.image) {
        <app-image
          [src]="booking.service.image"
          [alt]="booking.service.name"
          preset="avatar"
          aspectRatio="1"
          [sizes]="'72px'"
          [width]="72"
          [height]="72"
          imgClass="booking__image-img"
          class="booking__image-media"
          [fill]="true"
        ></app-image>
        <img
          class="booking__image-img booking__image-img--fallback"
          [src]="booking.service.image"
          [alt]="booking.service.name"
        />
      }
      @if (!booking.service.image) {
        <div class="booking__image-placeholder">
          <i class="fa-solid fa-image"></i>
        </div>
      }
    </div>

    <div class="booking__service-details">
      <p class="booking__label">
        <i class="fa-solid fa-briefcase booking__label-icon"></i>
        <span>{{ 'bookings.service.title' | transloco }}</span>
      </p>
      <p class="booking__primary">{{ booking.service.name }}</p>
      <div class="booking__price-row">
        <span class="booking__price">{{ getFinalPrice() | currency:'EUR' }}</span>
        @if (hasDiscount()) {
          <span class="booking__discount">-{{ getDiscountPercentage() }}%</span>
        }
      </div>
    </div>
  </div>

  <div class="booking__column booking__column--date">
    <p class="booking__label">
      <i class="fa-solid fa-user booking__label-icon"></i>
      <span>{{ 'bookings.customer.title' | transloco }}</span>
    </p>
    <p class="booking__primary">
      @if (booking.customer.firstname || booking.customer.lastname) {
        <span>
          {{ booking.customer.firstname }} {{ booking.customer.lastname }}
        </span>
      }
      @if (!booking.customer.firstname && !booking.customer.lastname) {
        <span>-</span>
      }
    </p>
    <p class="booking__muted">{{ booking.customer.email }}</p>
  </div>

  <div class="booking__column">
    <p class="booking__label">
      <i class="fa-regular fa-calendar booking__label-icon"></i>
      <span>{{ 'bookings.date.title' | transloco }}</span>
    </p>
    <p class="booking__primary booking__date">
      {{ getFormattedDate() }}
    </p>
  </div>

  <div class="booking__column booking__column--center-vertically">
    <div class="booking__status booking__status--{{ booking.status }}">
      <p>{{ ('bookings.status.' + booking.status) | transloco }}</p>
    </div>
  </div>

  <div class="booking__column booking__actions booking__column--center-vertically">
    <button class="booking__icon-button"
      type="button"
      (click)="goToBooking($event)"
      [attr.aria-label]="'bookings.actions.check' | transloco"
      >
      <i class="fa-solid fa-arrow-right"></i>
    </button>
  </div>
</div>
